import 'fotorama/fotorama';

(function($){
  "use strict";

  var $fotorama = $('.fotorama');
  var $btnShowGallery = $('#js-btn-show-gallery');
  var $btnShowInformations = $('#js-btn-show-informations');
  var $carGallery = $('#js-car-gallery');
  var $carInformations = $('#js-car-informations');


  var gallery = $fotorama.fotorama({
    transition: "slide",
    nav: "thumbs",
    thumbwidth: 150,
    thumbheight: 150,
    thumbmargin: 0,
    thumbborderwidth: 0,
    thumbfit: "cover",
    navposition: "left",
    ratio: "1.33333333",
    width: "100%",
    minheight: "200",
    maxheight: "94.9%",
    fit: "scaledown"
  });
  if($(window).width() > 1024) {
    $fotorama.fotorama({
      thumbwidth: 200,
      thumbheight: 200
    });
  } else {
    $fotorama.fotorama({
      thumbwidth: 80,
      thumbheight: 80
    });
  }

  $fotorama.one('fotorama:ready fotorama:load', function (e, fotorama, extra) {
    if($(window).width() > 1024) {
      $('.fotorama__active img').addClass('is-no-left');
    }
  });

  $btnShowGallery.bind('click', function(e) {
    e.preventDefault();
    $(this).addClass('is-hidden');
    $(this).hide();
    $('.fotorama__active img').removeClass('is-no-left');
    $btnShowInformations.addClass('is-visible');
    $carInformations.addClass('is-hidden');
    $carGallery.addClass('is-full');
  });

  $btnShowInformations.bind('click', function(e) {
    e.preventDefault();
    $(this).removeClass('is-visible');
    $btnShowGallery.fadeIn();
    setTimeout(function() {
      $btnShowGallery.removeClass('is-hidden');
    }, 16);
    $carInformations.removeClass('is-hidden');
    $carGallery.removeClass('is-full');
    $('.fotorama__active img').addClass('is-no-left');
  });

})(jQuery);
